import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ByMerchantRequestDto, GetMerchantPayoutAccountResponseDto, PayoutAccountTypeEnum, PayServiceTypeEnum, PayServiceTypeModel } from 'app/models';
import { MerchantService } from 'app/services';
import { MessageService } from 'primeng/api';
import { MerchantPaymentMethodModalComponent } from '../merchant-payment-method-modal/merchant-payment-method-modal.component';

@Component({
  selector: 'merchant-payment-view',
  templateUrl: './merchant-payment-view.component.html',
  styleUrls: ['./merchant-payment-view.component.css',
    '../../merchant-store-onboarding.component.scss',
    '../../../../../../styles/m3-defaul-material-theme.scss']
})
export class MerchantPaymentViewComponent implements OnInit {
  @Input() merchantId: number = 0;
  @Output() hidePaymentGridViewEmit = new EventEmitter<any>();

  payments: [GetMerchantPayoutAccountResponseDto] = [{
    MerchantId: 0,
    UsePaymayaAccount: false,
    PayoutAccountTypeId: PayoutAccountTypeEnum.None,
    AccountName: '',
    AccountNumber: '',
    RejectReason: '',
    PayServiceId: PayServiceTypeEnum.None,
    PayServiceName: ''
  }];

  showPaymentMethodSidebar: boolean = false;

  isMerchant: boolean = false;
  paymentMerchantId: number = 0;
  merchanUser: any = null;

  loading: boolean = false;
  payoutAccountTypeEnum = PayoutAccountTypeEnum;
  selectedPaymentMethod: GetMerchantPayoutAccountResponseDto = {
    MerchantId: 0,
    UsePaymayaAccount: false,
    PayoutAccountTypeId: PayoutAccountTypeEnum.None,
    AccountName: '',
    AccountNumber: '',
    RejectReason: '',
    PayServiceId: PayServiceTypeEnum.None,
    PayServiceName: ''
  };
  paymentMethods = PayServiceTypeModel.CommonPaymentMethods;
  payServiceTypeName: string = '';

  public showMerchantStoreDetailSideBar: boolean = false;
  public storeId: number = 0;
  //-------------------------------------------------------------
  //------------------MerchantAddPayment---------------------
  public showMerchantDetailPaymentSideBar: boolean = false;


  public openMerchantDetailPaymentSideBar() {
    this.showMerchantDetailPaymentSideBar = !this.showMerchantDetailPaymentSideBar;
  }
  changedShowMerchantDetailPaymentSideBarEmit(value: any) {
      this.showMerchantDetailPaymentSideBar = value;
  }

  dialog = inject(MatDialog);

  constructor(private merchantService: MerchantService,
    private messageService: MessageService
  ) {}

  ngOnInit() {
    this.getMerchantPayoutAccounts();
  }
  openPaymentMethodSidebar(selectedPaymentMethod: any){
    this.showPaymentMethodSidebar = true;
    this.selectedPaymentMethod = selectedPaymentMethod;
  }
  closePaymentMethodSidebar(event: any){
    this.showPaymentMethodSidebar = event;
  }
  deletePaymentMethod(merchantId: number){
    this.loading = true;
    const payload: ByMerchantRequestDto = {
      MerchantId: merchantId
    };
    this.merchantService.deleteMerchantPayoutAccount(payload, this.messageService).then((res) =>{
      if(res?.Success){
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Your payment method has been successfully deleted.' });
      }
      this.getMerchantPayoutAccounts();
      this.hidePaymentGridViewEmit.emit();
      this.loading = false;
    }).catch((err => {
      throw err;
    }));
  }

  getMerchantPayoutAccounts() {
      this.loading = true;
      const payload: ByMerchantRequestDto = {
          MerchantId: this.merchantId
      };
      this.merchantService.getMerchantPayoutAccounts(payload, this.messageService)
      .then(data => {
          if(!data?.Success || data?.Items == null){
              this.hidePaymentGridViewEmit.emit();
              this.loading = false;
              return;
          }

          this.payments = data?.Items.map((x: GetMerchantPayoutAccountResponseDto) => ({
            MerchantId: x.MerchantId,
            UsePaymayaAccount: x.UsePaymayaAccount,
            PayoutAccountTypeId: x.PayoutAccountTypeId,
            AccountName: x.AccountName,
            AccountNumber: x.AccountNumber,
            RejectReason: x.RejectReason,
            PayServiceId: x.PayServiceId,
            PayServiceName: this.getPayServiceTypeName(x.PayServiceId)
          }));

          this.loading = false;
      })
      .catch(err => {
          this.loading = false;
          throw err;
      });
  }

  getPayServiceTypeName(payServiceType: PayServiceTypeEnum): string{
    return this.paymentMethods.find(x => x.value === payServiceType)?.name;
  }

  showCreatePaymentMethodDialog(){
    const addPaymentDialog = this.dialog.open(MerchantPaymentMethodModalComponent, {
      width: '70%',
      maxWidth: '1000px',
      disableClose: true,
      data:{
        isCreate: true,
        header: 'Add',
        merchantId: this.merchantId
      }
    });

    addPaymentDialog.afterClosed().subscribe(result => {
      if(result){
        this.hidePaymentGridViewEmit.emit();
        this.getMerchantPayoutAccounts();
      }
    });
  }
}
